import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/lib/analytics";
import { metaPageView } from "@/lib/metaPixel";
import { captureAttribution } from "@/lib/attribution";
import { setCanonical } from "@/lib/seo";

/** Meldet jeden SPA-Routenwechsel als page_view an GA4 (nur mit Consent)
 *  und hält Canonical-URL + og:url aktuell (SEO). */
export default function PageViewTracker() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    captureAttribution();
    trackPageView(pathname + search);
    metaPageView();
    setCanonical(pathname);
  }, [pathname, search]);
  return null;
}
